import type React from 'react';
import { useEffect } from 'react';

import { TABLE_ROW_SIZE } from '../../constants';

interface UseDynamicHeightFromRowsParams {
  ref: React.RefObject<HTMLDivElement | null>;
  tableRowsCount: number;
  tableRowSize?: number;
  fallbackHeight?: string;
}

const useDynamicHeightFromRows = ({
  ref,
  tableRowsCount,
  tableRowSize = TABLE_ROW_SIZE,
  fallbackHeight = '--pageMainSectionHeight'
}: UseDynamicHeightFromRowsParams) => {
  useEffect(() => {
    if (ref.current) {
      let height = `${window.innerHeight}px`;
      const rowsHeight = tableRowsCount * tableRowSize;
      if (rowsHeight < window.innerHeight) {
        height = getComputedStyle(document.documentElement).getPropertyValue(fallbackHeight);
      }
      ref.current.style.setProperty('height', height);
    }
  }, [ref, tableRowsCount, tableRowSize, fallbackHeight]);
};

export default useDynamicHeightFromRows;
